/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as TermsRouteImport } from './routes/terms';
import { Route as PrivacyRouteImport } from './routes/privacy';
import { Route as HowItWorksRouteImport } from './routes/how-it-works';
import { Route as DemosRouteImport } from './routes/demos';
import { Route as ContactRouteImport } from './routes/contact';
import { Route as IndexRouteImport } from './routes/index';

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any);
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRouteImport,
} as any);
const DemosRoute = DemosRouteImport.update({
  id: '/demos',
  path: '/demos',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/how-it-works': typeof HowItWorksRoute;
  '/privacy': typeof PrivacyRoute;
  '/terms': typeof TermsRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/how-it-works': typeof HowItWorksRoute;
  '/privacy': typeof PrivacyRoute;
  '/terms': typeof TermsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/contact': typeof ContactRoute;
  '/demos': typeof DemosRoute;
  '/how-it-works': typeof HowItWorksRoute;
  '/privacy': typeof PrivacyRoute;
  '/terms': typeof TermsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/contact'
    | '/demos'
    | '/how-it-works'
    | '/privacy'
    | '/terms';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/contact' | '/demos' | '/how-it-works' | '/privacy' | '/terms';
  id:
    | '__root__'
    | '/'
    | '/contact'
    | '/demos'
    | '/how-it-works'
    | '/privacy'
    | '/terms';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ContactRoute: typeof ContactRoute;
  DemosRoute: typeof DemosRoute;
  HowItWorksRoute: typeof HowItWorksRoute;
  PrivacyRoute: typeof PrivacyRoute;
  TermsRoute: typeof TermsRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms';
      path: '/terms';
      fullPath: '/terms';
      preLoaderRoute: typeof TermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/privacy': {
      id: '/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/how-it-works': {
      id: '/how-it-works';
      path: '/how-it-works';
      fullPath: '/how-it-works';
      preLoaderRoute: typeof HowItWorksRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/demos': {
      id: '/demos';
      path: '/demos';
      fullPath: '/demos';
      preLoaderRoute: typeof DemosRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contact': {
      id: '/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof ContactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactRoute: ContactRoute,
  DemosRoute: DemosRoute,
  HowItWorksRoute: HowItWorksRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
